export var TaxErrorEnum;
(function (TaxErrorEnum) {
    TaxErrorEnum["ERROR_DATA"] = "errorData";
    TaxErrorEnum["DOWNLOADSTATUS"] = "downloadStatus";
    TaxErrorEnum["EMAILSTATUS"] = "emailStatus";
})(TaxErrorEnum || (TaxErrorEnum = {}));
